

















































import { defineComponent, computed, useContext } from '@nuxtjs/composition-api';
import { SfBanner, SfLink, SfImage, } from '@storefront-ui/vue';

export default defineComponent({
    components: {
        SfBanner,
        SfLink,
        SfImage,
    },
    props: {

    },
    setup(props) {
        const context = useContext();
        // @ts-ignore
        const { imageProvider, magentoBaseUrl } = context.$vsf.$magento.config;

        return {
            magentoBaseUrl
        };
    },
});
